"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmraSignupRequestSchema () {
        return EmraSignupRequestSchema;
    },
    get SignupRequestSchema () {
        return SignupRequestSchema;
    },
    get SignupResponseSchema () {
        return SignupResponseSchema;
    }
});
const _zod = require("zod");
const _email = require("./email");
const SignupRequestSchema = _zod.z.object({
    email: _email.EmailAddressSchema,
    password: _zod.z.string().min(12).max(256),
    displayName: _zod.z.string().optional()
});
const SignupResponseSchema = _zod.z.object({
    userId: _zod.z.string().min(1)
});
const EmraSignupRequestSchema = _zod.z.object({
    tenantSlug: _zod.z.string().min(1),
    email: _email.EmailAddressSchema,
    password: _zod.z.string().min(12).max(256),
    displayName: _zod.z.string().optional()
});
